import { TabEditForm } from "js/jsx/src/classes/tab/tabEditForm.jsx";

export default function edit() {

    var renderEditForm = function (renderMethod) {
        if (!renderMethod)
            renderMethod = quosal.ui.react.update;

        var tab = app.currentQuote.Tabs.firstOrNull((s) => s.IdQuoteTabs == quosal.util.queryString('idquotetabs')) || {};
        var formConfiguration = quosal.customization.forms.bindForm(quosal.customization.forms['TabEdit'].Configurations[quosal.settings.getValue('TabEdit_FormConfiguration') || 'Default'], tab);
        if (formConfiguration == null || !formConfiguration.Panels) {
            formConfiguration = quosal.customization.forms.formConfigurationFix('TabEdit', quosal.settings.getValue('TabEdit_FormConfiguration'));
        }

        renderMethod(<TabEditForm configuration={formConfiguration}
            tab={tab} />, document.getElementById('fluid_tab-edit'));
    };

    var loadEditForm = function () {
        renderEditForm(quosal.ui.react.render);

        $('#pageName').val('tab.edit');
    };

    var updateEditForm = function () {
        renderEditForm();
    };

    var changeFormConfiguration = function () {
        renderEditForm();
    };

    var unbindEvents = function () {
        quosal.customization.forms.configurationChanged.unbind(changeFormConfiguration);
        quosal.customization.forms.configurationUpdated.unbind(changeFormConfiguration);
        quosal.sell.quote.onUpdate.unbind(updateEditForm);
        quosal.navigation.onNavigate.unbind(unbindEvents);
    };

    quosal.navigation.onNavigate.bind(unbindEvents);
    quosal.customization.forms.configurationChanged.bind(changeFormConfiguration);
    quosal.customization.forms.configurationUpdated.bind(changeFormConfiguration);
    quosal.sell.quote.onUpdate.bind(updateEditForm);

    loadEditForm();
}